import React, { Component } from "react";
import PropTypes from "prop-types";

class AccordionSection extends Component {
  static propTypes = {
    children: PropTypes.instanceOf(Object).isRequired,
    isOpen: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired
  };

  onClick = () => {
    this.props.onClick(this.props.label);
  };

  render() {
    const { onClick, props: { isOpen, label } } = this;

    return (
      <li className={`navigation--item ${isOpen ? 'active' : ''}`}>
        <button onClick={onClick} className="navigation--item__link">
          {label}
          <i>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M18.5859 8.00001C18.9764 7.60949 19.6096 7.60949 20.0001 8.00001C20.3906 8.39054 20.3906 9.0237 20.0001 9.41423L12.7072 16.7071C12.3167 17.0976 11.6835 17.0976 11.293 16.7071L4.00007 9.41423C3.60955 9.0237 3.60955 8.39054 4.00008 8.00001C4.3906 7.60949 5.02376 7.60949 5.41429 8.00001L11.293 13.8787C11.6835 14.2692 12.3167 14.2692 12.7072 13.8787L18.5859 8.00001Z" fill="#52288E"/>
          </svg>
          </i>
        </button>
        {isOpen && (
          this.props.children
        )}
      </li>
    );
  }
}

export default AccordionSection;
